import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  selectCustomerId,
  selectTransformedThreads,
  transformAndSetThreads,
} from 'src/presentation/components/pages/sidekick/threads/actions/threadsUiSlice';
import sidekickThreadsResource from 'src/actions/sidekick/sidekickThreadsResource';
import useResource, { STATUS_FAILED, STATUS_LOADING, STATUS_SUCCEEDED } from 'src/presentation/hooks/useResource';

// TODO: use in different components
export default () => {
  const dispatch = useDispatch();
  const customerId = useSelector(selectCustomerId);

  const [loadingState, setLoadingState] = useState(STATUS_LOADING);
  const items = useSelector(selectTransformedThreads);
  const {
    errors,
    loadingState: threadsLoadingState,
    values: rawThreads,
  } = useResource(sidekickThreadsResource, {
    fetch: true,
    params: { customerId },
  });

  useEffect(() => {
    if (threadsLoadingState === STATUS_SUCCEEDED) {
      dispatch(transformAndSetThreads(rawThreads));
      setLoadingState(STATUS_SUCCEEDED);
    }
    if (threadsLoadingState === STATUS_FAILED) {
      setLoadingState(STATUS_FAILED);
    }
  }, [dispatch, rawThreads, threadsLoadingState, setLoadingState]);

  return {
    errors,
    items,
    loadingState,
  };
};
